module.exports = __webpack_public_path__ + "img/novos-contratos-ano-mes.428982b3.png";